/*globals $:false */

import ImporterStatsAdvancedSearchM from "./model/recordm.importer.model.stats.advancedsearch.js";
import ImporterStatsSearchM from "./model/recordm.importer.model.stats.simplesearch.js";
import ImporterStatsSearchResultP from "./presenter/recordm.presenter.searchresult.importer.stats.js";
import MultipleSearchP from "./presenter/recordm.presenter.multiplesearch.js";
import RecordmImporterSummaryStatM from "./model/recordm.importer.model.stat.summary.js";
import SearchVisGroupM from "./model/recordm.model.searchvisgroup.js";
import tmpl from "./templates/search-definition.dot";

const SearchRmImporterStats = function(core) {
    let _running = false;

    let _$mainContainer;

    let _searchP,
        _searchResultP;

    let _viewId,
        _searchQuery;

    const _dummyStatM = new RecordmImporterSummaryStatM(core);

    // load all _views associated with this definition
    const _loadViews = function(settingKey, onDone) {
        SearchVisGroupM.loadAll(core, settingKey, function(views) {
            onDone(views);
        });
    };

    const _init = function(searchMode, searchQuery, activeVisualizationId) {
        _running = true;

        _searchQuery = searchQuery;
        _viewId = (activeVisualizationId !== "undefined"
                   ? parseInt(activeVisualizationId, 10)
                   : undefined);

        _loadViews(_dummyStatM.getSettingKey(), function(views) {
            const visualizationGroupM = new SearchVisGroupM(core, _dummyStatM, views);
            let searchM;

            const advSearchM = new ImporterStatsAdvancedSearchM(core,
                "recordm/importer-stats/search/advanced",
                "recordm/importer-stats/download/advanced",
                "recordm/importer-stats/download"
            );

            const simpleSearchM = new ImporterStatsSearchM(core, "start_date", "desc");

            _$mainContainer = $(tmpl());
            if(_running) _$mainContainer.appendTo('#'+core.getAppInstanceId());
            _$mainContainer.removeClass("hidden");

            if (searchMode === 'aq') {
                try {
                    _searchQuery = JSON.parse(searchQuery || []);
                } catch (e) {
                    // if there's malformed json in the url don't error out.
                    _searchQuery = [];
                }
                searchM = advSearchM;
            } else {

                if(!_searchQuery){
                    _searchQuery = "*";
                }

                searchM = simpleSearchM;
            }

            //In this module we only want to show the "summary" stats for each imported file
            searchM.filterSummaryStats();

            _searchP = MultipleSearchP(
                core,
                "importer-stats",
                $(".js-search-container", _$mainContainer),
                _dummyStatM,
                simpleSearchM,
                advSearchM,
                visualizationGroupM
            );

            _searchResultP = new ImporterStatsSearchResultP(
                core,
                searchM,
                visualizationGroupM,
                $(".js-results-container", _$mainContainer)
            );
            _searchResultP.init(searchQuery, _viewId);

            _searchP.init(_searchQuery, _viewId);
            _searchP.prepareView();
        });
    };

    const _pause = function() {
        _running = false;
        if (_dummyStatM) {
            _searchP.pause();
            _searchResultP.pause();

            _$mainContainer.detach();
        }
    };

    const _resume = function() {
        _running = true;
        if (_dummyStatM) {
            _$mainContainer.appendTo('#'+core.getAppInstanceId());

            _searchP.resume();
            _searchResultP.resume();

            _searchP.prepareView();
            _searchResultP.prepareView();
        }
    };

    const _destroy = function() {
        _running = false;
        if (_dummyStatM) {
            _searchP.destroy();
            _searchResultP.destroy();

            _$mainContainer.remove();

            _dummyStatM.release();
        }
    };

    const _getDescription = function() {

    };

    return {
        init: _init,
        pause: _pause,
        resume: _resume,
        destroy: _destroy,
        getDescription: _getDescription
    }
};

export default SearchRmImporterStats;
